<!-- eslint-disable -->
<template>
  <div class="contain">
    <img class="bg-img" src="../../assets/login-bg.jpg" alt="quiz" />
    <div class="login-content">
        <h2 class="title">QUIZ</h2>
        <el-input placeholder="账号" v-model="user_name"></el-input>
        <el-input placeholder="密码" v-model="password" show-password></el-input>
        <el-button type="primary" @click="loginIn()" :disabled="!user_name || !password">登录</el-button>
    </div>
  </div>
</template>
<!-- eslint-disable -->

<script>
export default {
    name: 'QuizLogin',
    data() {
        return {
            user_name: '',
            password: ''
        };
    },
    created() {
        this.$axios(this.path.checkUserloginStatus())
            .then(res => {
                // 登录token没失效直接跳转页面
                this.$router.push('/quiz-menu');
            });
    },
    methods: {
        loginIn() {
            this.$axios(this.path.checkUserInformation(this.user_name, this.password))
                .then(res => {
                    this.$message.success({
                        message: res.msg,
                        duration: 1000,
                        onClose: () => {
                            // 登入接口存入cookie
                            window.localStorage.setItem('User-Token', res.data.user_token);
                            window.localStorage.setItem('User-Name', res.data.name);
                            window.localStorage.setItem('is_administrators', res.data.is_administrators);
                            this.$router.push('/quiz-menu');
                        }
                    });
                });
        }
    }
};
</script>

<style lang="less" scoped>
.contain {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .bg-img {
        position: absolute;
        left: 0px;
        top: 0px;
        object-fit: cover;
        width: 100%;
        height: 100%;
        filter: blur(36px);
    }
    .login-content {
        position: relative;
        top: -10%;
        z-index: 100;
        padding: 48px;
        width: 360px;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 8px;
        .title {
            font-size: 78px;
            line-height: 100px;
        }
        .el-input {
            margin-bottom: 16px;
            /deep/ .el-input__inner {
                height: 48px;
                font-size: 18px;
                &::placeholder {
                    color: #999;
                }
            }
        }
        .el-button {
            width: 100%;
            height: 48px;
            font-size: 22px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/quiz-login/index.vue